import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Box, Typography } from '@mui/material';
import { msalInstance } from '../../authProvider';

// Simple signed-out page: stays here until user clicks Sign In.
export default function SignedOutPage() {
  const navigate = useNavigate();
  const location = useLocation();
  // If user is already signed in (has active or cached account), push them back home.
  useEffect(() => {
    try {
      const active = msalInstance.getActiveAccount();
      const accounts = msalInstance.getAllAccounts();
      if ((active || accounts.length > 0) && location.pathname.includes('/signed-out')) {
        navigate('/', { replace: true });
      }
    } catch (e) {
      console.warn('SignedOutPage redirect check failed:', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
  const handleSignIn = () => {
    msalInstance.loginRedirect({ scopes: ['user.read'] });
  };

  return (
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'60vh', gap:2}}>
      <Typography variant="h5">You have signed out</Typography>
      <Typography variant="body1" sx={{maxWidth:480, textAlign:'center'}}>
        This window will remain here until you choose to sign in again.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleSignIn}>Sign In</Button>
    </Box>
  );
}
